import React from 'react';
import { Layout, Menu } from 'antd';
import type { MenuProps } from 'antd';
import { 
  DashboardOutlined, 
  UserOutlined, 
  BankOutlined,
  GlobalOutlined,
  SettingOutlined 
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

const { Sider } = Layout;

interface SidebarProps {
  collapsed: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasRole, user } = useAuth();
  const { t } = useTranslation();

  // Определяем пункты меню в зависимости от роли
  let menuItems: MenuProps['items'];

  if (user?.role === 'TRANSLATOR') {
    // Для TRANSLATOR показываем только Менеджер переводов
    menuItems = [
      {
        key: '/translations/manager',
        icon: <GlobalOutlined />,
        label: t('navigation.translationManager'),
        onClick: () => navigate('/translations/manager'),
      },
    ];
  } else {
    // Полное меню для остальных ролей
    menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: t('navigation.dashboard'),
      onClick: () => navigate('/dashboard'),
    },
    ...(hasRole(['SUPERADMIN', 'ADMIN']) ? [{
      key: '/users',
      icon: <UserOutlined />,
      label: t('navigation.users'),
      onClick: () => navigate('/users'),
    }] : []),
    {
      key: '/campaigns',
      icon: <BankOutlined />,
      label: t('navigation.campaigns'),
      onClick: () => navigate('/campaigns'),
    },
    ...(hasRole(['TRANSLATOR', 'ADMIN', 'SUPERADMIN']) ? [{
      key: 'translations-menu',
      icon: <GlobalOutlined />,
      label: t('navigation.translations'),
      children: [
        {
          key: '/translations',
          label: t('navigation.languages'),
          onClick: () => navigate('/translations'),
        },
        {
          key: '/translations/manager',
          label: t('navigation.translationManager'),
          onClick: () => navigate('/translations/manager'),
        },
        {
          key: '/translations/projects',
          label: t('navigation.projects'),
          onClick: () => navigate('/translations/projects'),
        }
      ]
    }] : []),
    {
      type: 'divider' as const,
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: t('navigation.settings'),
      onClick: () => navigate('/settings'),
    },
  ];
  }

  const selectedKeys = [location.pathname];

  return (
    <Sider 
      trigger={null} 
      collapsible 
      collapsed={collapsed}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <div 
        style={{
          height: 32,
          margin: 16,
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: collapsed ? '12px' : '16px',
        }}
      >
        {collapsed ? 'OX' : 'OX Corp'}
      </div>
      
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={selectedKeys}
        items={menuItems}
        style={{ borderRight: 0 }}
      />
    </Sider>
  );
};

export default Sidebar;
